<script>
    import {onDestroy, onMount} from "svelte";
    import {dataStore} from "../stores/dataStore";
    import {popupStore} from "../stores/popupStore";
    import htmlParser from "../lib/htmlParser";

    // Static Data and Placeholders
    let language = window.location.href.split('/')[3] === 'en' ? 1 : 0;
    const popupId = "popupId"; // value doesn't matter
    let goBackText = language ? "Go Back" : "Powrót";
    // let info = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem fuga aperiam soluta! Labore quasi illum aut suscipit expedita ducimus provident"

    export let dateKey;
    export let dateKeyValue;
    export let hallKey;
    export let diabetechSessions;


    let isPopupOpen;
    let foundHour = null;
    popupStore.subscribe(value => {
        isPopupOpen = value;
    });

    const findObjectWithName = (data, targetName) => {
        for (const [key, value] of Object.entries(data)) {
            if (value.name === targetName) {
                return value;
            }
        }
        return null;
    }

    function findObjectWithGivenName(data, targetName) {
        for (const hour of Object.values(data.hours)) {
            for (const [sessionKey, session] of Object.entries(hour.sessions)) {
                if (session.sala === targetName && dateKeyValue === sessionKey) {
                    foundHour = hour.name;
                    return session;
                }
            }
        }
        return null;
    }


    let foundDay = findObjectWithName(diabetechSessions, dateKey);
    let foundEvent = findObjectWithGivenName(foundDay, hallKey);
    const time = (foundHour || '').split('-').map(t => t.trim()).filter(Boolean).join('-');

    const detailRows = [
        {icon: 'type', label: 'Typ', value: foundEvent?.typ},
        {icon: 'date', label: 'Data', value: foundDay?.name},
        {icon: 'time', label: 'Czas', value: time},
        {icon: 'room', label: 'Sala', value: foundEvent?.sala},
    ].filter(row => row.value);

    function closePopup() {
        const url = new URL(window.location);
        url.searchParams.delete('id');
        window.history.pushState({}, '', url);
        popupStore.set(false);
    }

    const handleScrollBehavior = () => {
        if (isPopupOpen) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "auto";
        }
    }

    onMount(() => {
        handleScrollBehavior();
        enableOutsideClick();
    });

    onDestroy(() => {
        handleScrollBehavior();
        disableOutsideClick();
    });

    let listenerFunc;
    let ignoreFirstClick = true;
    // Function to handle adding the event listener
    const enableOutsideClick = () => {
        const popupNode = document.getElementById(popupId);
        listenerFunc = (e) => {
            if (ignoreFirstClick) {
                ignoreFirstClick = false;
                return;
            }
            if (popupNode && !popupNode.contains(e.target)) {
                closePopup();
            }
        }
        document.addEventListener("click", listenerFunc);


    };

    // Function to handle removing the event listener
    const disableOutsideClick = () => {
        document.removeEventListener("click", listenerFunc);
    };

</script>

<svelte:window on:keydown={(e) => e.key === 'Escape' && closePopup()}/>

<div class="popup-overlay popup-modal">
    <div class="popup-card" id={popupId} role="dialog" aria-modal="true" aria-labelledby="popup-title">
        <div class="popup-toolbar">
            <button type="button" class="popup-back" on:click={closePopup}>
                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                    <path d="M15 18l-6-6 6-6" fill="none" stroke="currentColor" stroke-width="2.5"
                          stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                {goBackText}
            </button>
        </div>

        <div class="popup-body">
            <h2 class="popup-title" id="popup-title">{foundEvent && foundEvent.name ? foundEvent.name : ''}</h2>
            {#if foundEvent && foundEvent.podtytul}
                <div class="popup-subtitle">{@html foundEvent.podtytul}</div>
            {/if}

            {#if detailRows.length}
                <dl class="popup-meta">
                    {#each detailRows as row}
                        <div class="popup-meta-row">
                            <dt>
                                <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none"
                                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    {#if row.icon === 'type'}
                                        <path d="M6 3h12v18l-6-4-6 4z"/>
                                    {:else if row.icon === 'date'}
                                        <rect x="3" y="5" width="18" height="16" rx="2"/>
                                        <path d="M3 10h18M8 3v4M16 3v4"/>
                                    {:else if row.icon === 'time'}
                                        <circle cx="12" cy="12" r="9"/>
                                        <path d="M12 7v5l3 2"/>
                                    {:else}
                                        <path d="M12 21s-7-6.2-7-11.5A7 7 0 0 1 19 9.5C19 14.8 12 21 12 21z"/>
                                        <circle cx="12" cy="9.5" r="2.5"/>
                                    {/if}
                                </svg>
                                {row.label}:
                            </dt>
                            <dd class:tabular={row.icon === 'time'}>{row.value}</dd>
                        </div>
                    {/each}
                </dl>
            {/if}

            {#if foundEvent && foundEvent.przewodniczacy}
                <section class="popup-section">
                    <h3>Prowadzący</h3>
                    <p class="popup-person">{foundEvent.przewodniczacy}</p>
                </section>
            {/if}

            {#if foundEvent && foundEvent.opis}
                <section class="popup-section popup-description">{@html foundEvent.opis}</section>
            {/if}
        </div>
    </div>
</div>

<style>
    .popup-overlay {
        position: fixed;
        inset: 0;
        z-index: 100000;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        margin: 0;
        padding: 80px 16px 24px;
    }

    .popup-card {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 720px;
        max-height: 100%;
        overflow: hidden;
        color: #3f3e3c;
        text-align: left;
        background: white;
        border-radius: 12px;
        box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
    }

    .popup-toolbar {
        flex: none;
        display: flex;
        padding: 12px 16px;
        border-bottom: 1px solid #ececec;
    }

    .popup-back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 14px 6px 10px;
        font-size: 15px;
        font-weight: 600;
        color: white;
        background: #9ca3af;
        border-radius: 999px;
        transition: background-color 0.15s ease;
    }

    .popup-back:hover,
    .popup-back:focus-visible {
        background: #6b7280;
    }

    .popup-back:focus-visible {
        outline: 3px solid #2189a6;
        outline-offset: 2px;
    }

    .popup-body {
        overflow-y: auto;
        padding: 24px 32px 32px;
    }

    .popup-title {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        line-height: 1.25;
        color: #3f3e3c;
    }

    .popup-subtitle {
        margin-top: 8px;
        font-size: 16px;
        line-height: 1.5;
        color: #5f5e5c;
    }

    .popup-meta {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 2px;
        width: 100%;
        margin: 20px 0 0;
        overflow: hidden;
        border-radius: 8px;
    }

    .popup-meta-row {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 10px 14px;
        background: rgb(226 236 254);
    }

    .popup-meta dt {
        display: flex;
        flex: none;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        font-weight: 700;
        color: #3f3e3c;
    }

    .popup-meta dt svg {
        flex: none;
        color: #1d7891;
    }

    .popup-meta dd {
        margin: 0;
        font-size: 16px;
        color: #3f3e3c;
    }

    .tabular {
        font-variant-numeric: tabular-nums;
    }

    .popup-section {
        margin-top: 24px;
    }

    .popup-section h3 {
        margin: 0 0 6px;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #1d7891;
    }

    .popup-person {
        margin: 0;
        font-size: 16px;
        line-height: 1.5;
    }

    .popup-description {
        font-size: 16px;
        line-height: 1.6;
        color: #3f3e3c;
    }

    .popup-description :global(p) {
        margin: 0 0 0.75em;
    }

    .popup-description :global(ul),
    .popup-description :global(ol) {
        margin: 0 0 0.75em;
        padding-left: 1.25em;
        list-style: disc;
    }

    .popup-description :global(a) {
        color: #1d7891;
        text-decoration: underline;
    }

    @media only screen and (max-width: 480px) {
        .popup-meta {
            grid-template-columns: minmax(0, 1fr);
        }
    }

    @media only screen and (max-width: 600px) {
        .popup-overlay {
            padding: 64px 8px 8px;
        }

        .popup-body {
            padding: 20px 18px 24px;
        }

        .popup-title {
            font-size: 20px;
        }
    }
</style>
